var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
          attrs: {
            top: "50px",
            "close-on-click-modal": false,
            title: _vm.isEdit ? "编辑" : "新建",
            visible: _vm.show,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
            close: _vm.onClear,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "margin-top-10",
              attrs: {
                "label-width": "130px",
                rules: _vm.rules,
                model: _vm.form,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("p", { staticClass: "title" }, [
                        _c(
                          "span",
                          {
                            staticClass: "margin-left-10",
                            staticStyle: { "vertical-align": "middle" },
                          },
                          [_vm._v("基本信息")]
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称", prop: "name" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "415px" },
                            attrs: {
                              disabled: _vm.isEdit,
                              clearable: "",
                              placeholder: "不超过10个字",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "is-required",
                              attrs: { label: "隶属公司", prop: "merchanList" },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: { click: _vm.handleMerchant },
                                    },
                                    [_vm._v("添加")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "margin-left-10",
                                      attrs: {
                                        "true-label": 1,
                                        "false-label": 0,
                                      },
                                      on: { change: _vm.onAllChange },
                                      model: {
                                        value: _vm.form.shiFouSuoYouXianLu,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "shiFouSuoYouXianLu",
                                            $$v
                                          )
                                        },
                                        expression: "form.shiFouSuoYouXianLu",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                全部\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "padding-left": "66px",
                                    "box-sizing": "border-box",
                                  },
                                },
                                _vm._l(
                                  _vm.merchantList,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.merchantId,
                                        staticClass: "margin-bottom-10",
                                      },
                                      [
                                        _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-remove-outline",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeMerchan(index)
                                              },
                                            },
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "margin-left-10" },
                                            [_vm._v(_vm._s(item.merchantName))]
                                          ),
                                        ]),
                                        Array.isArray(item.line) &&
                                        item.line.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "box-card" },
                                              _vm._l(
                                                item.line,
                                                function (citem, index) {
                                                  return _c(
                                                    "el-checkbox",
                                                    {
                                                      key: index,
                                                      staticStyle: {
                                                        "margin-left": "0",
                                                      },
                                                      attrs: {
                                                        size: "mini",
                                                        "true-label": "1",
                                                        "false-label": "2",
                                                        border: true,
                                                      },
                                                      model: {
                                                        value: citem.check,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            citem,
                                                            "check",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "citem.check",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            citem.lineName
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "隶属公司",
                                prop: "merchantNames",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.form.shiFouSuoYouXianLu === 1
                                      ? "全部"
                                      : _vm.form.merchantNames
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "可用线路", prop: "lineNames" } },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.form.shiFouSuoYouXianLu === 1
                                      ? "全部"
                                      : _vm.form.lineNames
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "可参与订单数",
                            prop: "huoDongCiShu",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "415px" },
                            attrs: {
                              disabled: _vm.isEdit,
                              placeholder: "请输入订单数",
                              max: 999999,
                              min: 1,
                              label: "请输入整数",
                            },
                            model: {
                              value: _vm.form.huoDongCiShu,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "huoDongCiShu", _vm._n($$v))
                              },
                              expression: "form.huoDongCiShu",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "预算金额", prop: "huoDongZongJinE" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "415px" },
                            attrs: {
                              disabled: _vm.isEdit,
                              placeholder: "请输入预算金额",
                              max: 999999,
                              min: 1,
                            },
                            model: {
                              value: _vm.form.huoDongZongJinE,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "huoDongZongJinE",
                                  _vm._n($$v)
                                )
                              },
                              expression: "form.huoDongZongJinE",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间", prop: "time" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "415px" },
                            attrs: {
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "picker-options": _vm.pickerOptions,
                              type: "datetimerange",
                              align: "left",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "default-time": ["00:00:00", "23:59:59"],
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                            },
                            model: {
                              value: _vm.form.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "time", $$v)
                              },
                              expression: "form.time",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "使用说明", prop: "describe" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "415px" },
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 6, maxRows: 8 },
                              placeholder: "展示在乘客端，可用线路自动添加",
                              maxlength: "500",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.describe,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "describe", $$v)
                              },
                              expression: "form.describe",
                            },
                          }),
                          _vm.form.describe && _vm.lineStr
                            ? _c(
                                "div",
                                { staticClass: "flex-start text-eli" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-redFont font-13 margin-right-5",
                                    },
                                    [_vm._v("活动线路无需填写，自动拼接")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "text" },
                                      on: { click: _vm.showRule },
                                    },
                                    [_vm._v("预览规则")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "使用条件", prop: "withNewUser" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "仅新用户可用",
                              "inactive-text": "",
                            },
                            model: {
                              value: _vm.form.withNewUser,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "withNewUser", $$v)
                              },
                              expression: "form.withNewUser",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "与优惠券互斥", prop: "withCoupon" },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              disabled: true,
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "",
                              "inactive-text": "",
                            },
                            model: {
                              value: _vm.form.withCoupon,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "withCoupon", $$v)
                              },
                              expression: "form.withCoupon",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "font-12 color-redFont margin-left-10",
                            },
                            [_vm._v("开启表示下单立减活动不可与优惠券叠加使用")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否可重复参与",
                            prop: "shiFouChongFu",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "",
                              "inactive-text": "",
                            },
                            model: {
                              value: _vm.form.shiFouChongFu,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "shiFouChongFu", $$v)
                              },
                              expression: "form.shiFouChongFu",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "font-12 color-redFont margin-left-10",
                            },
                            [_vm._v("开启表示用户可多次参与活动")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "扫码补票是否可用",
                            prop: "buPiaoShiFouKeYong",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "",
                              "inactive-text": "",
                            },
                            model: {
                              value: _vm.form.buPiaoShiFouKeYong,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "buPiaoShiFouKeYong", $$v)
                              },
                              expression: "form.buPiaoShiFouKeYong",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "font-12 color-redFont margin-left-10",
                            },
                            [_vm._v("开启表示扫描司机补票码可用该优惠")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否关联渠道码",
                            prop: "enableChannelCode",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                  "active-text": "",
                                  "inactive-text": "",
                                },
                                model: {
                                  value: _vm.form.enableChannelCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "enableChannelCode", $$v)
                                  },
                                  expression: "form.enableChannelCode",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "font-12 color-redFont margin-left-10",
                                },
                                [
                                  _vm._v(
                                    "开启表示仅通过扫描渠道码下单的用户可享受立减活动优惠"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.channelShow
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "关联渠道码",
                                prop: "channelIdList",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "position-relative" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "415px" },
                                      attrs: {
                                        multiple: "",
                                        filterable: "",
                                        remote: "",
                                        "reserve-keyword": "",
                                        placeholder: "请输入关键词",
                                        loading: _vm.loading,
                                      },
                                      model: {
                                        value: _vm.form.channelIdList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "channelIdList",
                                            $$v
                                          )
                                        },
                                        expression: "form.channelIdList",
                                      },
                                    },
                                    _vm._l(_vm.channelOptions, function (item) {
                                      return _c(
                                        "el-popover",
                                        {
                                          key: item.id,
                                          attrs: {
                                            width: "200",
                                            trigger: "hover",
                                            placement: "right",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "channel-dialog" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-weight",
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "tit" },
                                                    [_vm._v("地址：")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "txt" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.address)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "tit" },
                                                    [_vm._v("负责人：")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "txt" },
                                                    [_vm._v(_vm._s(item.admin))]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "tit" },
                                                    [_vm._v("邮箱：")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "txt" },
                                                    [_vm._v(_vm._s(item.email))]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "tit" },
                                                    [_vm._v("电话：")]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(_vm._s(item.phone)),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "tit" },
                                                    [_vm._v("备注：")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "txt" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.remark)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex-1" },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "tit" },
                                                        [_vm._v("新用户首单：")]
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.fristOrder /
                                                              100
                                                          ) + "%"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex-1" },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "tit" },
                                                        [_vm._v("常规订单：")]
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.commondOrder /
                                                              100
                                                          ) + "%"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("el-option", {
                                            attrs: {
                                              slot: "reference",
                                              label: item.name,
                                              value: item.id,
                                            },
                                            slot: "reference",
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.channelShow
                        ? _c("MarketingDialogConfig", {
                            ref: "marketingConfig",
                            model: {
                              value: _vm.marketingConfig,
                              callback: function ($$v) {
                                _vm.marketingConfig = $$v
                              },
                              expression: "marketingConfig",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "padding-left-10", attrs: { span: 12 } },
                    [
                      _c("p", { staticClass: "title" }, [
                        _c(
                          "span",
                          {
                            staticClass: "margin-left-10",
                            staticStyle: { "vertical-align": "middle" },
                          },
                          [_vm._v("优惠条件")]
                        ),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "优惠条件", prop: "tiaoJian" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.tiaoJian,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "tiaoJian", $$v)
                                },
                                expression: "form.tiaoJian",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "margin-left-5 margin-right-10",
                                  },
                                  [_vm._v("金额")]
                                ),
                                _c("span", [_vm._v("满**元可用")]),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "margin-left-5 margin-right-10",
                                  },
                                  [_vm._v("人数")]
                                ),
                                _c("span", [_vm._v("满**人可用")]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "优惠内容", prop: "youHuiNeiRong" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.youHuiNeiRong,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "youHuiNeiRong", $$v)
                                },
                                expression: "form.youHuiNeiRong",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(" 立减金额 "),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(" 折扣 "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        _vm._l(_vm.conditionList, function (item, index) {
                          return _c(
                            "el-row",
                            { key: item.uuid },
                            [
                              _c("el-col", { attrs: { span: 22 } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex-top padding-10 color-bg-f6 border-radius-10",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "color-main margin-top-5",
                                      },
                                      [
                                        _vm._v(
                                          "层级" + _vm._s(index + 1) + "："
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "margin-left-10 flex-1" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex-start" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-20 font-weight color-redFont margin-right-5",
                                              },
                                              [_vm._v("*")]
                                            ),
                                            _vm.form.tiaoJian === 1
                                              ? [
                                                  _vm._v(
                                                    "\n                        优惠门槛：满"
                                                  ),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "60px",
                                                      margin: "0 5px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      min: 1,
                                                    },
                                                    model: {
                                                      value: item.topMoney,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "topMoney",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "item.topMoney",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "元\n                      "
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm.form.tiaoJian === 2
                                              ? [
                                                  _vm._v(
                                                    "\n                        优惠门槛：满"
                                                  ),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "60px",
                                                      margin: "0 5px",
                                                    },
                                                    attrs: {
                                                      size: "mini",
                                                      min: 1,
                                                    },
                                                    model: {
                                                      value: item.topPeople,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "topPeople",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "item.topPeople",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "人\n                      "
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-center margin-top-20",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-20 font-weight color-redFont margin-right-5",
                                                },
                                                [_vm._v("*")]
                                              ),
                                              _c("span", [
                                                _vm._v("优惠内容："),
                                              ]),
                                              _vm.form.youHuiNeiRong === 1
                                                ? _c(
                                                    "div",
                                                    { staticClass: "flex-1" },
                                                    [
                                                      _vm._v(
                                                        "\n                          减"
                                                      ),
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "60px",
                                                          margin: "0 5px",
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          min: 1,
                                                        },
                                                        model: {
                                                          value:
                                                            item.liJianMoney,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "liJianMoney",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "item.liJianMoney",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "元\n                        "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.form.youHuiNeiRong === 2
                                                ? _c(
                                                    "div",
                                                    { staticClass: "flex-1" },
                                                    [
                                                      _vm._v(
                                                        "\n                          打"
                                                      ),
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "60px",
                                                          margin: "0 5px",
                                                        },
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value: item.zheKou,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "zheKou",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.zheKou",
                                                        },
                                                      }),
                                                      _vm._v("折，最高优惠"),
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "60px",
                                                          margin: "0 5px",
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          min: 1,
                                                        },
                                                        model: {
                                                          value:
                                                            item.maxYouHuiMoney,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "maxYouHuiMoney",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.maxYouHuiMoney",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "元\n                        "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm.form.youHuiNeiRong === 2
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "font-12 color-redFont margin-y-0 margin-left-2 margin-top-3",
                                                },
                                                [
                                                  _vm._v(
                                                    "折扣区间：1-10，小数点保留1位"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c(
                                  "div",
                                  { staticClass: "flex-center flex-1" },
                                  [
                                    index === 0
                                      ? [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: "新增优惠段",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("el-button", {
                                                attrs: {
                                                  size: "mini",
                                                  circle: "",
                                                  type: "primary",
                                                  icon: "el-icon-plus",
                                                },
                                                on: { click: _vm.addContent },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: "删除优惠",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("el-button", {
                                                attrs: {
                                                  size: "mini",
                                                  type: "danger",
                                                  circle: "",
                                                  icon: "el-icon-delete",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.remove(index)
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { "label-width": "90px" } }, [
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "el-popconfirm",
                      {
                        attrs: { title: "确定取消吗？" },
                        on: {
                          confirm: function ($event) {
                            return _vm.onClear("form", "show")
                          },
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "reference",
                              type: "danger",
                              size: "mini",
                            },
                            slot: "reference",
                          },
                          [_vm._v("取消")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "margin-left-20",
                        attrs: {
                          type: "primary",
                          size: "mini",
                          loading: _vm.loading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSubmit("form")
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "50px",
            title: "使用说明",
            visible: _vm.visible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c("div", { staticClass: "font-12 color-333" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "white-space": "pre-line",
                  "line-height": "30px",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.form.describe.replace(/^\s*/, "")) +
                    "\n      "
                ),
              ]
            ),
            _c("p", [_vm._v(" 活动路线：" + _vm._s(_vm.lineStr) + " ")]),
          ]),
        ]
      ),
      _c("select-merchant", {
        ref: "merchant",
        on: { submit: _vm.getMerchantList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }